// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"35f7c83d","542":"0be4148d","782":"53f5b7c8"}[chunkId] + ".chunk.css";
};